module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lois Richer\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("With almost two million books in print worldwide, in suspense and romance genres, Lois Richer writes about characters bold enough to face life's problems head on. Lois works hard to leave readers with a sense of hope as well as a hunger to know more about the God of whom she writes. Married for 25 years, Lois and her husband love to travel. Their small prairie town offers the perfect home base to contemplate God's inifinite love."), _c('BR'), _c('BR', [_c('BR')], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/oKagav/tc-custom/9781488007330.jpg?1738384984573",
      "alt": "This image is the cover for the book Rancher's Family Wish, Wranglers Ranch"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Rancher's Family Wish, Wranglers Ranch\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A home is more than a roof and four walls . . .")]), _c('br'), _c('br'), _vm._v("All Tanner Johns ever wanted was a place to call home. After inheriting Wranglers Ranch, Tanner is determined to carry on with his guardian’s legacy and turn it into a camp for troubled kids."), _c('br'), _c('br'), _vm._v("Widow Sophie Armstrong is just as focused on her goals—and on raising her two young children alone. Meeting the rugged cowboy changes everything. Tanner is a natural with her kids, and he lightens Sophie’s load in ways she couldn’t have imagined. But as the shadows in his past come between them, Tanner must convince Sophie he’s a man she can count on—for keeps.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0